import {
  type ColumnSet,
  type ICardListSelectProps,
  isColumnCardListSubmMenu,
} from '../../../../shared/ui/card-list';
import type { ReportBuilderDeliverable } from '../report-builder.model';

function flattenColumnSet<T>(columnSet: ColumnSet<T>) {
  return columnSet.columns.reduce((flattenedColumns, columnItem) => {
    if (isColumnCardListSubmMenu(columnItem)) {
      return [...flattenedColumns, ...columnItem.menuItems];
    }
    return [...flattenedColumns, columnItem];
  }, [] as ICardListSelectProps<T>[]);
}

export const getReportBuilderReportIndex = (
  columnSet: ColumnSet<string>[],
  reportType: string | number
  // @ts-expect-error noUncheckedIndexedAccess
) => flattenColumnSet(columnSet[0]).findIndex((x) => x.id === reportType);
export const createNewReportBuilderEntity = (
  columnSet: ColumnSet<string>[],
  reportType: string
): {
  newId: number;
  newEntity: ReportBuilderDeliverable | ReportBuilderDeliverable[];
} => {
  const newId = getReportBuilderReportIndex(columnSet, reportType);

  const entityToAdd: ReportBuilderDeliverable = {
    id: newId,
    reportType: reportType,
    selections: {},
  };

  return {
    newId,
    newEntity: entityToAdd,
  };
};
